// Auth utility functions for handling both JWT tokens and cookies

const setAuthCookie = async (
  token: string,
  remember: boolean = false,
): Promise<void> => {
  try {
    const response = await fetch('/v2/auth/set-cookie', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ token, remember }),
    })

    if (!response.ok) {
      throw new Error('Failed to set auth cookie')
    }

    await response.json()
  } catch (error) {
    console.error('Error setting auth cookie:', error)
    throw error
  }
}

const clearAuthCookie = async (): Promise<void> => {
  try {
    const response = await fetch('/v2/auth/clear-cookie', {
      method: 'POST',
    })

    if (!response.ok) {
      throw new Error('Failed to clear auth cookie')
    }

    await response.json()
  } catch (error) {
    console.error('Error clearing auth cookie:', error)
    throw error
  }
}

export const AuthCookieUtils = {
  setAuthCookie,
  clearAuthCookie,
}
